import React from 'react';
import { XIcon, CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const BEFORE = ['Dudas constantes', 'Práctica inestable', 'Información confusa', 'Dependencia externa'];
const AFTER = ['Claridad y confianza', 'Práctica diaria simple', 'Conexión real', 'Autonomía espiritual'];
export function BeforeAfterSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f0eaf7] py-20 md:py-28 px-4" data-id="element-18">
      <div className="container mx-auto max-w-3xl" data-id="element-19">
        <h2 ref={ref1} className={`reveal text-3xl md:text-5xl font-serif font-bold text-gray-900 text-center mb-14 leading-tight ${vis1 ? 'is-visible' : ''}`} data-id="element-20">
          🔄 Antes vs Después
        </h2>

        <div ref={ref2} className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${vis2 ? '' : ''}`} data-id="element-21">
          <div className={`reveal-left bg-white rounded-2xl p-8 border-2 border-red-100 shadow-sm ${vis2 ? 'is-visible' : ''}`} data-id="element-22">
            <h3 className="text-xl font-bold text-red-500 mb-6 flex items-center gap-2" data-id="element-23">
              <XIcon className="w-6 h-6" strokeWidth={3} data-id="element-24" /> Antes
            </h3>
            <ul className="space-y-4" data-id="element-25">
              {BEFORE.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-600 text-lg" data-id="element-26">
                  <span className="w-2 h-2 bg-red-300 rounded-full flex-shrink-0" data-id="element-27"></span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className={`reveal-right bg-white rounded-2xl p-8 border-2 border-green-200 shadow-md ring-1 ring-green-100 ${vis2 ? 'is-visible' : ''}`} style={{
          transitionDelay: '100ms'
        }} data-id="element-28">
            <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center gap-2" data-id="element-29">
              <CheckIcon className="w-6 h-6" strokeWidth={3} data-id="element-30" /> Después
            </h3>
            <ul className="space-y-4" data-id="element-31">
              {AFTER.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-800 font-medium text-lg" data-id="element-32">
                  <div className="bg-green-100 p-0.5 rounded-full flex-shrink-0" data-id="element-33">
                    <CheckIcon className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-34" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}